/* eslint-disable import/prefer-default-export */
export const ROOT_SLICE = 'StoreXYMinMax';

export const ID_KEY_APPLICATION = 'APPLICATION';
